// extracted by mini-css-extract-plugin
export default {"dropzone":"dropzone__a6N4x","drag-active":"drag-active__icK8Q"};